import { productIntroductionRouting } from './productIntroduction'
import { Home } from './home/Home'
import {aboutUsRouting} from './aboutUs/routing'
import {servicesRouting} from './services/routing'
import {recruitmentRouting} from './recruitment/routing'
import {errorRouting} from './404/routing'
import {qrCodeRouting} from './qrCode/routing'
import Layout from 'components/layout/DefaultLayout'//默认布局组件

//路由信息
export const routes = {
  path: '/',
  name: '首页',
  component: Layout,
  indexRoute: { component: Home},
  childRoutes: [
    ...productIntroductionRouting,
    ...aboutUsRouting,
    ...servicesRouting,
    ...recruitmentRouting,
    ...errorRouting,
    ...qrCodeRouting
  ]
}



// WEBPACK FOOTER //
// ./modules/routing.js